exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".addcontacts-1{fill:none}.addcontacts-2{fill:#ee7470;opacity:.331}.addcontacts-3{fill:#1e4e69}.addcontacts-4,.addcontacts-6{fill:#72cac2}.addcontacts-4{opacity:.375}.addcontacts-5{fill:#faedb1}.addcontacts-6{stroke:#fff}.addcontacts-7{fill:#fff}\n", ""]);
